import builder from '../builder';
import RailroadTrain from '../../streamline-icons/light/railroad-train.svg';

export default builder('IconRailroadTrainLight', RailroadTrain);
